var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWihoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 98,
    viewBox: "0 0 129 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7397 37.7803L86.3772 61.6884L52.9282 85.6616C50.3116 87.537 46.7958 87.5428 44.1695 85.6761C41.5431 83.8094 40.3831 80.4802 41.2796 77.3823L52.7397 37.7803Z",
    fill: "#FFD951"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_517_1103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 37,
    width: 47,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7397 37.7803L86.3772 61.6884L52.9282 85.6616C50.3116 87.537 46.7958 87.5428 44.1695 85.6761C41.5431 83.8094 40.3831 80.4802 41.2796 77.3823L52.7397 37.7803Z",
    fill: "#FFD951"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_517_1103)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1916 66.6092C77.7821 66.2399 71 62.8749 63.8645 57.8033C56.7332 52.7347 51.3222 47.435 49.8408 44.33C48.7534 44.301 47.968 44.5521 47.57 45.1156C45.853 47.5463 51.9911 54.8687 61.2798 61.4707C70.5685 68.0728 79.4904 71.4544 81.2074 69.0238C81.6061 68.4593 81.5812 67.631 81.1916 66.6092Z",
    fill: "#B154FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8077 76.6463C71.5855 76.877 64.2593 73.512 56.6053 68.0718C48.9511 62.6315 43.3575 56.8136 42.5066 53.6878C41.7493 53.8348 41.1754 54.1515 40.8228 54.6505C38.8197 57.4863 44.7258 65.1371 54.0146 71.7391C63.3033 78.3412 72.4571 81.3944 74.4603 78.5587C74.8128 78.0597 74.9203 77.4115 74.8077 76.6463Z",
    fill: "#B154FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.763 86.2258C65.6665 87.9933 57.2614 85.0598 48.8408 79.0747C40.4173 73.0877 34.871 66.1032 35.5113 62.588C35.1538 62.8246 34.8517 63.1125 34.611 63.4532C32.0356 67.0991 37.4777 75.4067 46.7665 82.0088C56.0552 88.6108 65.673 91.0072 68.2485 87.3613C68.4885 87.0216 68.6588 86.6414 68.763 86.2258Z",
    fill: "#B154FA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5,
    filter: "url(#filter0_f_517_1103)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0382 90.5361L81.1731 61.2903L74.6379 54.9926L42.9413 89.7565L44.0382 90.5361Z",
    fill: "#FFFB9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.5,
    filter: "url(#filter1_f_517_1103)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9613 85.2777L54.1588 40.4396L73.2632 50.7129L42.2519 87.6166L38.9613 85.2777Z",
    fill: "url(#paint0_linear_517_1103)"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 20.6342,
    ry: 4.49027,
    transform: "matrix(0.815091 0.579333 -0.576961 0.816771 69.5576 49.7339)",
    fill: "url(#paint1_linear_517_1103)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0895 5.85059C28.0179 5.85059 27.9462 5.85059 27.8745 5.85059C26.3934 5.85059 25.6289 4.90037 25.0317 4.11306C24.4822 3.40718 24.1478 3.0271 23.455 3.0271C22.7622 3.0271 22.4516 3.40718 21.8783 4.11306C21.281 4.87323 20.5166 5.85059 19.0354 5.85059C17.5543 5.85059 16.7898 4.90037 16.1926 4.11306C15.6431 3.40718 15.3086 3.0271 14.6158 3.0271C13.9231 3.0271 13.6125 3.40718 13.0391 4.11306C12.4419 4.87323 11.6774 5.85059 10.1963 5.85059V3.92301C10.8891 3.92301 11.1997 3.54292 11.773 2.83705C12.3702 2.07688 13.1347 1.09952 14.6158 1.09952C16.097 1.09952 16.8615 2.04973 17.4587 2.83705C18.0082 3.54292 18.3426 3.92301 19.0354 3.92301C19.7282 3.92301 20.0388 3.54292 20.6121 2.83705C21.2094 2.07688 21.9738 1.09952 23.455 1.09952C24.9361 1.09952 25.7006 2.04973 26.2978 2.83705C26.8473 3.54292 27.1817 3.92301 27.8745 3.92301C27.9462 3.92301 28.0179 3.92301 28.0895 3.92301V5.85059Z",
    fill: "#E0E2EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.074 79.9996C119.161 79.9996 116.812 77.8208 116.812 75.1648C116.812 72.5088 119.161 70.3301 122.074 70.3301C124.988 70.3301 127.337 72.4881 127.337 75.1648C127.337 77.8416 124.965 79.9996 122.074 79.9996ZM122.074 73.6708C121.171 73.6708 120.448 74.3348 120.448 75.1648C120.448 75.9948 121.171 76.6588 122.074 76.6588C122.978 76.6588 123.7 75.9948 123.7 75.1648C123.7 74.3348 122.955 73.6708 122.074 73.6708Z",
    fill: "#E0E2EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40884 36.9998C1.52154 36.9998 0 35.5687 0 33.8241C0 32.0795 1.52154 30.6484 3.40884 30.6484C5.29614 30.6484 6.81768 32.0659 6.81768 33.8241C6.81768 35.5823 5.28151 36.9998 3.40884 36.9998ZM3.40884 32.8428C2.82363 32.8428 2.35547 33.2789 2.35547 33.8241C2.35547 34.3693 2.82363 34.8055 3.40884 34.8055C3.99405 34.8055 4.46222 34.3693 4.46222 33.8241C4.46222 33.2789 3.97942 32.8428 3.40884 32.8428Z",
    fill: "#E0E2EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8912 75.0289L13.4434 78.4346L16.838 81.8936L20.2859 78.488L16.8912 75.0289Z",
    fill: "#6371DD",
    fillOpacity: 0.6
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5938 40.3312C78.4847 46.0952 71.6713 52.4851 69.5283 54.9595L73.2971 57.3612C76.4747 53.9407 85.4901 47.5362 90.8107 44.0429C96.1313 40.5496 105.96 36.6924 110.32 35.5279L108.989 32.2529C106.403 32.544 98.703 34.5673 88.5938 40.3312Z",
    fill: "#6371DE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9773 5.4078L74.349 8.88519C76.4442 10.569 80.458 14.4593 79.7513 16.5502C78.8681 19.164 69.2916 19.5503 69.7118 22.6072C70.132 25.6642 75.5558 28.9654 76.4176 30.7155C77.2794 32.4656 61.4066 29.9825 59.8716 32.3746C58.6436 34.2883 62.94 42.6458 65.2418 46.5853L70.477 43.9944C68.6762 41.4393 64.9906 35.7179 64.6545 33.2724C64.2343 30.2154 76.617 34.4259 79.0245 31.6019C81.432 28.778 74.053 24.8119 73.8429 23.2834C73.6328 21.755 83.6617 17.8799 83.6831 13.5161C83.7003 10.025 79.2197 6.65596 76.9773 5.4078Z",
    fill: "#FF7E61"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.05 26.1027L84.0474 27.0732L85.0143 31.0883L89.017 30.1178L88.05 26.1027Z",
    fill: "#CE51FA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8166 48.1762L88.6494 51.6885L92.1506 53.8628L94.3178 50.3506L90.8166 48.1762Z",
    fill: "#FADF51"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.423 44.3421L102.44 45.6494L103.743 47.6383L105.726 46.331L104.423 44.3421Z",
    fill: "#51F0FA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.387 41.2126L44.8374 43.5273L47.1452 42.0727L45.6948 39.758L43.387 41.2126Z",
    fill: "#FAA251"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7335 16.8565L41.9639 16.2582C39.8803 19.3006 39.938 22.2865 40.9538 25.1279C41.9696 27.9694 45.9431 22.9119 47.6604 24.1171C49.3777 25.3223 44.0848 30.2459 45.9749 32.2901C47.865 34.3344 53.4301 29.5028 55.6553 30.0991C57.4353 30.5761 55.4303 35.2792 54.2053 37.5712L56.1111 38.2156C56.4234 37.4365 57.134 35.5326 57.4774 34.15C57.9066 32.4216 57.5348 29.0173 55.8594 28.1385C54.184 27.2597 49.268 31.0618 47.1319 30.6517C44.9958 30.2417 50.854 23.6358 49.6498 21.3551C48.4455 19.0744 44.6238 22.7781 42.6238 22.414C41.0238 22.1228 42.6969 18.5877 43.7335 16.8565Z",
    fill: "#BF8CFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7006 20.9625L61.1831 24.5244L64.7338 26.0472L66.2514 22.4853L62.7006 20.9625Z",
    fill: "#5FFA51",
    fillOpacity: 0.6
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.825 3.42486L101.051 8.13965L105.751 12.9284L110.524 8.21357L105.825 3.42486Z",
    fill: "#6371DD",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_517_1103",
    x: 35.9414,
    y: 47.9922,
    width: 52.2319,
    height: 49.5439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_517_1103"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_517_1103",
    x: 26.9614,
    y: 28.4395,
    width: 58.3018,
    height: 71.1768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_517_1103"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_517_1103",
    x1: 48.5637,
    y1: 62.3547,
    x2: 66.5161,
    y2: 75.0361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262661,
    stopColor: "#FD6C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37B38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_517_1103",
    x1: 40.8132,
    y1: 4.5563,
    x2: -3.687e-8,
    y2: 4.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD90F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120818,
    stopColor: "#FF9B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301115,
    stopColor: "#FFC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613383,
    stopColor: "#FFCD2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71487,
    stopColor: "#FFAD33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836431,
    stopColor: "#FFD133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949814,
    stopColor: "#FFBA33"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWihoo);
export default __webpack_public_path__ + "static/media/wihoo.aa881d5ba3cff6aa877acb8c55355cbf.svg";
export { ForwardRef as ReactComponent };